module.exports = __webpack_public_path__ + "static/media/avnt-brands-mockup.5517dffa.png";